__turbopack_context__.v({
  "DarkIcon": "Footer-module-scss-module__kQc2fa__DarkIcon",
  "Footer": "Footer-module-scss-module__kQc2fa__Footer",
  "FooterContent": "Footer-module-scss-module__kQc2fa__FooterContent",
  "FooterSpotonSignature": "Footer-module-scss-module__kQc2fa__FooterSpotonSignature",
  "FooterTitle": "Footer-module-scss-module__kQc2fa__FooterTitle",
  "LightIcon": "Footer-module-scss-module__kQc2fa__LightIcon",
  "SpotonSignatureDark": "Footer-module-scss-module__kQc2fa__SpotonSignatureDark",
  "SpotonSignatureLight": "Footer-module-scss-module__kQc2fa__SpotonSignatureLight",
});
